import { render, staticRenderFns } from "./HmwSlide.vue?vue&type=template&id=730e9081"
import script from "./HmwSlide.vue?vue&type=script&lang=js"
export * from "./HmwSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730e9081')) {
      api.createRecord('730e9081', component.options)
    } else {
      api.reload('730e9081', component.options)
    }
    module.hot.accept("./HmwSlide.vue?vue&type=template&id=730e9081", function () {
      api.rerender('730e9081', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/HmwSlide.vue"
export default component.exports